// cSpell:ignore draftjs textdata

interface DraftBlock {
  text: string;
}

interface DraftContent {
  blocks: DraftBlock[];
}

interface RichContentNode {
  textData?: { text?: string };
  nodes?: RichContentNode[];
}

interface RichContent {
  nodes: RichContentNode[];
}

const extractTextFromRichContentNodes = (nodes: RichContentNode[]): string =>
  nodes
    .map((node) => {
      if (node.textData?.text) {
        return node.textData.text;
      }
      if (node.nodes?.length) {
        return extractTextFromRichContentNodes(node.nodes);
      }
      return '';
    })
    .join('');

// Extracts plain text from a FAQ answer stored as either DraftJS or RichContent JSON.
// Used for SEO structured data — formatting metadata is intentionally ignored.
export const draftjsToPlainText = (draftjs: string | null | undefined): string => {
  if (!draftjs) {
    return '';
  }
  try {
    const parsed = JSON.parse(draftjs);
    // DraftJS format: { blocks: [{ text }] }
    if (Array.isArray(parsed?.blocks)) {
      return (parsed as DraftContent).blocks
        .map((block) => block.text)
        .join('\n')
        .trim();
    }
    // RichContent format: { nodes: [...] }
    if (Array.isArray(parsed?.nodes)) {
      return extractTextFromRichContentNodes((parsed as RichContent).nodes).trim();
    }
    return '';
  } catch {
    return '';
  }
};
